import { Aux } from './AuxillaryServices';
import { Log } from './Log';
import { Signage } from '../Signage';
import { glom } from '../Signage/glom';
import { envVar } from '../Utility';
import { Handlebars } from '../Utility/Handlebars/databaseHandlebars';
import { $ } from '../../vendor/jquery';
import { moment } from '../../vendor/moment';
import { stopCurrentDisplay, playCurrentDisplay } from '../Display';
import {
    numOfActiveAlerts,
    WEATHER_ALERT_CSS_CLASS,
} from '../EmergencyAlerts/EmergencyAlertsUtility';

const INTERVAL_MS = process.env.WEATHER_ALERTS_INTERVAL_MS
    ? parseInt(process.env.WEATHER_ALERTS_INTERVAL_MS)
    : 240000;

function WeatherAlertService() {
    var t = this;

    t.m_AlertConfig = null;
    t.m_WeatherAlertServiceTimeoutId = null;
    t.m_VisibleAlert = null;
    t.m_HbsRenderer = null;
    t.m_CssTemplateString = null;

    t.beginWeatherAlertMonitor = function () {
        //get configuration for this player
        if (glom.weatherAlertConfigurationId && Signage.playerUuid) {
            t.acquireWAConfiguration(glom.weatherAlertConfigurationId, Signage.playerUuid).then(
                function (config) {
                    if (!config.configuration) {
                        setTimeout(
                            t.acquireWAConfiguration,
                            10000,
                            glom.weatherAlertConfigurationId,
                            Signage.playerUuid
                        );
                    } else {
                        t.m_AlertConfig = config.configuration;

                        if (
                            t.m_AlertConfig.template &&
                            t.m_AlertConfig.custom_css &&
                            typeof t.m_AlertConfig.custom_css !== 'undefined'
                        ) {
                            var cssTemplate = JSON.parse(t.m_AlertConfig.custom_css);
                            t.m_CssTemplateString = cssTemplate[t.m_AlertConfig.template.id];

                            t.m_HbsRenderer = Handlebars.compile(
                                (t.m_CssTemplateString
                                    ? '<style>' + t.m_CssTemplateString + '</style>'
                                    : '') + t.m_AlertConfig.template.html
                            );
                            t.pollWASource(glom.weatherAlertConfigurationId);
                        }
                    }
                },
                function () {
                    setTimeout(
                        t.acquireWAConfiguration,
                        10000,
                        glom.weatherAlertConfigurationId,
                        Signage.playerUuid
                    );
                }
            );
        }
    };

    t.stopWeatherAlertMonitor = function () {
        //
    };

    t.acquireWAConfiguration = function (configId, playerUuid) {
        return $.ajax({
            dataType: 'json',
            cache: false,
            url:
                envVar(process.env.BASE_URL_EMERGENCY_ALERTS) +
                '/weather/configuration/by_id/' +
                configId,
            type: 'GET',
            data: {
                player_uuid: playerUuid,
            },
            timeout: 10000,
        });
    };

    t.pollWASource = function (configId) {
        if (t.m_WeatherAlertServiceTimeoutId) {
            clearTimeout(t.m_WeatherAlertServiceTimeoutId);
            t.m_WeatherAlertServiceTimeoutId = null;
        }

        $.ajax({
            dataType: 'json',
            cache: false,
            url: envVar(process.env.BASE_URL_EMERGENCY_ALERTS) + '/weather/feed',
            type: 'GET',
            data: {
                config_id: configId,
            },
            timeout: 10000,
        }).then(
            function (data) {
                t.m_WeatherAlertServiceTimeoutId = setTimeout(
                    t.pollWASource,
                    INTERVAL_MS,
                    configId
                );

                if (data && typeof data.alert !== 'undefined' && data.alert.length) {
                    //looks like we have an alert(s)!
                    t.showAlert(configId, data.alert[0]);
                } else {
                    t.clearAlert(configId);
                }
            },
            function () {
                t.clearAlert(configId);
                t.m_WeatherAlertServiceTimeoutId = setTimeout(
                    t.pollWASource,
                    INTERVAL_MS,
                    configId
                );
            }
        );
    };

    t.showAlert = function (configId, alertObj) {
        if (
            t.m_VisibleAlert &&
            t.m_VisibleAlert.identifier &&
            t.m_VisibleAlert.identifier !== alertObj.identifier
        ) {
            t.clearAlert(configId);
        }

        if (!t.m_VisibleAlert) {
            alertObj.nowDate = '<span class="alert-weather-now-date">#now#</span>';

            var context = {
                configId: configId,
                alertObj: alertObj,
            };

            if (Signage.localTimeZone && alertObj.effectiveDate) {
                try {
                    var pubDateFormat =
                        t.m_AlertConfig && t.m_AlertConfig.date_format
                            ? t.m_AlertConfig.date_format
                            : 'LLL';

                    var pubDate = moment.tz(alertObj.effectiveDate, 'UTC');

                    var publishDate = pubDate.tz(Signage.localTimeZone).format(pubDateFormat);

                    alertObj.effectiveDate =
                        publishDate !== 'Invalid date' ? publishDate : alertObj.effectiveDate;
                } catch (e) {
                    Log.Info(e.message, null, __fileline, e);
                }
            }

            t.m_VisibleAlert = alertObj;

            //full screen alert
            $('body').append(
                '<div id="weather-alert-container-' +
                    configId +
                    `" class="${WEATHER_ALERT_CSS_CLASS}" ` +
                    'style="z-index:99999; width:100%;height:100%;position:absolute;">' +
                    t.m_HbsRenderer(context) +
                    '</div>'
            );

            const textFillAlert = function () {
                //textfill
                if (t.m_AlertConfig.template.type === 'html') {
                    $('body')
                        .find('.weather-alert-description')
                        .textfill({
                            minFontPixels: 32,
                            maxFontPixels: 150,
                            changeLineHeight: true,
                            allowOverflow: true,
                            success: function () {
                                console.log('debug: text fill success');
                            },
                            fail: function (error) {
                                console.log('debug: text fill fail', error);
                                $('body')
                                    .find('.weather-alert-description span')
                                    .css({ 'font-size': 32 });
                            },
                        });
                    $('body')
                        .find('.weather-alert-title span')
                        .textfill({
                            minFontPixels: 32,
                            maxFontPixels: 150,
                            changeLineHeight: true,
                            allowOverflow: true,
                            success: function () {
                                console.log('debug: text fill success');
                            },
                            fail: function (error) {
                                console.log('debug: text fill fail', error);
                                $('body')
                                    .find('.weather-alert-title span')
                                    .css({ 'font-size': 32 });
                            },
                        });
                }
            };

            if (t.m_AlertConfig.template && t.m_AlertConfig.template.type) {
                textFillAlert();
            }

            var bringAlertToFront = function () {
                if (t.m_VisibleAlert) {
                    try {
                        stopCurrentDisplay();
                    } catch (dontneederrormessage) {
                        // if it fails to bring the alert to the front at first,
                        // we still want to continue to make sure that it can be
                        // attempted to be brought to the front in 5 seconds
                        // from now
                    }

                    // HACK!!! keep trying incase the signage is still loading
                    setTimeout(bringAlertToFront, 5000);
                }
            };

            if (t.m_AlertConfig.template && t.m_AlertConfig.template.type) {
                setTimeout(textFillAlert, 10000);
            }

            setTimeout(bringAlertToFront, 5000);
        }
    };

    t.clearAlert = function (configId) {
        if (t.m_VisibleAlert) {
            $('#weather-alert-container-' + configId).remove();

            if (numOfActiveAlerts() === 0) {
                void playCurrentDisplay();
            }
        }

        t.m_VisibleAlert = null;
    };
}

function WeatherAlertBase() {}

WeatherAlertBase.Mechanism = null;
WeatherAlertBase.m_Loaded = false;

WeatherAlertBase.onServiceDiscovered = function (event) {
    switch (event) {
        case 'Initialize': {
            if (!WeatherAlertBase.Mechanism) {
                WeatherAlertBase.Mechanism = new WeatherAlertService();

                Aux.RegisterService('WeatherAlert', WeatherAlertBase.Mechanism);
            }

            break;
        }
        case 'ServicesDiscovered':
        case 'DiscoveryFailed': {
            WeatherAlertBase.Mechanism.beginWeatherAlertMonitor();
            break;
        }
    }
};

/**
 * @todo document this
 */
function initializeWeatherAlerts() {
    Aux.AddListener(WeatherAlertBase.onServiceDiscovered);
}

export { initializeWeatherAlerts };
